function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6675 23.722C20.037 23.722 24.3898 19.3692 24.3898 13.9998C24.3898 8.63038 20.037 4.27759 14.6675 4.27759C9.2981 4.27759 4.94531 8.63038 4.94531 13.9998C4.94531 19.3692 9.2981 23.722 14.6675 23.722Z",
  stroke: "#6A6F73",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9922 8.16626V19.8329",
  stroke: "#6A6F73",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6933 10.1108H13.6424C13.141 10.1108 12.6602 10.3157 12.3056 10.6804C11.9511 11.045 11.752 11.5396 11.752 12.0553C11.752 12.571 11.9511 13.0656 12.3056 13.4302C12.6602 13.7949 13.141 13.9997 13.6424 13.9997H16.343C16.8444 13.9997 17.3252 14.2046 17.6797 14.5692C18.0343 14.9339 18.2334 15.4285 18.2334 15.9442C18.2334 16.4599 18.0343 16.9544 17.6797 17.3191C17.3252 17.6838 16.8444 17.8886 16.343 17.8886H11.752",
  stroke: "#6A6F73",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgRewardStatus = function SvgRewardStatus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRewardStatus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reward-status.1b71969d.svg";
export { ForwardRef as ReactComponent };